import React, { useState, useRef } from 'react';

interface AutoPlayVideoProps {
  url: string;
  alt: string;
}

const AutoPlayVideo: React.FC<AutoPlayVideoProps> = ({ url, alt }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  const handleLoadedData = () => {
    setIsLoaded(true);
  };

  if (!url) return <>No Video URL</>;

  return (
    <video
      ref={videoRef}
      src={url}
      autoPlay
      muted
      loop
      playsInline
      controls={false}
      onLoadedData={handleLoadedData}
      style={{
        width: '100%',
        opacity: isLoaded ? 1 : 0,
        transition: 'opacity 300ms ease-in-out',
      }}
      aria-label={alt ?? 'Video File'}
    >
      <source src={url} type="video/mp4" />
      Sorry, your browser does not support embedded videos.
    </video>
  );
};

export default AutoPlayVideo;
